import React from "react";
import { Link } from "react-router-dom";
import siteConfig, { formatPrice } from "../Datas/siteConfig";
import "../css/delivery.scss";

const questions = [
  ["How much is delivery?", `Standard tracked delivery is a flat ${formatPrice(siteConfig.defaultShipping)} per order.`],
  ["When will my order leave?", "In-stock orders normally leave our Hong Kong fulfilment point within one to three business days."],
  ["Can I change my order?", "Email us as soon as possible. We can amend an order only before it has entered packing or been handed to the carrier."],
  ["How do sizing and colours work?", "Available sizes and colours appear on each product page. Screens can display colour differently, so small variations are normal."],
  ["What is your return window?", `Contact us within ${siteConfig.returnsWindowDays} days of delivery. Items must remain unused, unworn and in their original packaging.`],
  ["How should I care for my item?", "Follow the care guide on the product page and the label supplied with the piece. When in doubt, use cool water and gentle handling."],
  ["Which payment methods are supported?", "Checkout supports major card networks and any additional methods shown securely by our payment provider."],
];

export default function Faqs() {
  return (
    <main className="policy-page" id="main-content">
      <header className="policy-page__header">
        <p className="policy-page__eyebrow">Customer care</p>
        <h1>FAQs</h1>
        <p>Quick answers about orders, delivery, returns and product care.</p>
      </header>
      <article className="policy-page__content" style={{ maxWidth: 980, margin: "0 auto" }}>
        {questions.map(([question, answer], index) => (
          <section key={question}>
            <span className="policy-page__number" aria-hidden="true">{String(index + 1).padStart(2, "0")}</span>
            <div><h2>{question}</h2><p>{answer}</p></div>
          </section>
        ))}
        <p>Still need help? <Link to="/contact">Contact customer care</Link> or email <a href={`mailto:${siteConfig.contact.customerServiceEmail}`}>{siteConfig.contact.customerServiceEmail}</a>.</p>
      </article>
    </main>
  );
}
